// extracted by mini-css-extract-plugin
export default {"blockContainer":"BlockSwiper_blockContainer__T58wn","swipeContainer":"BlockSwiper_swipeContainer__vtvH2"};